/*
 *  ************************************************************************
 *  *  © [2015 - 2024] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React, { useState } from "react";
import chevron from "../../../../../../assets/icons/down-arrow.svg";
import { SvgHandler } from "../../../../svg-handler/svg-handler";
import "./description.m.css";

export const Description = ({ data, descriptionTitle, mode, type = "plan", displayDescription = false }) => {
  const [showDescription, setDescription] = useState(displayDescription);
  const updatedDescriptionTitle = descriptionTitle || "What's Included";
  const updatedStyle = mode === "dark" ? "description-wrapper dark" : "description-wrapper";

  return (
    <div styleName={updatedStyle} className={showDescription ? "transform description" : "hidden description"}>
      <div className="description-title" styleName="description-title" onClick={() => setDescription(!showDescription)}>
        {updatedDescriptionTitle}
        <span styleName="chevron-wrapper">
          <SvgHandler xlinkHref={chevron} width="24" height="24" />
        </span>
      </div>
      <div styleName="description" data-test-id={`${type}-description`} dangerouslySetInnerHTML={{ __html: data }} />
    </div>
  );
};
